import React from 'react'

import Section from 'components/smartSearch/SidebarSection/SidebarSection'

import Link from '../Link/Link'

import s from './BrandLinks.scss'


const getBrandLink = ({ gender, name }) => {
  const brand = name.replace(/\s/g, '-').toLowerCase()
  const tail  = gender === 'female' ? '-perfumes' : '-colognes'

  return `/${brand}${tail}`
}

const BrandLinks = ({ gender, brands }) => {
  const links = (
    brands
      .filter(({ name }) => Boolean(name))
      .map(({ name, count, value }, index) => {
        const link = getBrandLink({ name, gender })

        return (
          <Link key={index} className={s.link} to={link}>
            {name} ({count})
          </Link>
        )
      })
  )

  return (
    <Section>{links}</Section>
  )
}

export default BrandLinks
